import { Errors } from '../enums/errors';
export class StorageError extends Error {
    /**
     * Represents a storage resolution error.
     *
     * @param code - The error code.
     * @param message - The error message.
     */
    constructor(code = Errors.STORAGE_ERROR, message = 'Storage Error') {
        super(message);
        /**
         * Status code for http related errors.
         */
        this.status = -1;
        /**
         * FileId related to the storage request failure.
         */
        this.fileId = '';
        /**
         * Additional debugging information for the error.
         */
        this.debug = {};
        /**
         * True if the error breaks the ability to play tracks ie. if the user has
         *     been play capped.
         */
        this.canPlayNext = true;
        this.code = code;
        this.message = message;
        this.name = 'StorageError';
    }
}
//# sourceMappingURL=storage.js.map